import { VoteIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex items-center justify-center text-white group">
          <div className="bg-white/10 p-3 rounded-xl group-hover:bg-white/20 transition-colors">
            <VoteIcon className="h-12 w-12" />
          </div>
          <span className="ml-3 text-3xl font-bold">SnapVote</span>
        </Link>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
          Make Better Decisions Together
        </h2>
        <p className="mt-2 text-center text-sm text-primary-200 max-w-md mx-auto">
          Join our community and start making informed decisions with collective wisdom
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-xl rounded-lg sm:px-10 border border-white/20">
          {children}
        </div>
      </div>

      <div className="mt-8 text-center">
        <p className="text-sm text-primary-200">
          By continuing, you agree to our{' '}
          <Link to="/terms" className="font-medium text-white hover:text-primary-100 underline">
            Terms of Service
          </Link>{' '}
          and{' '}
          <Link to="/privacy" className="font-medium text-white hover:text-primary-100 underline">
            Privacy Policy
          </Link>
        </p>
      </div>
    </div>
  );
}